<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
  <span class="w-full input-field p-input-icon-right">
    <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" class="w-full" />
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="filters.name.value = null; search()"></i>
  </span>
</div>
-->

<p-table #grid [value]="guardsShifts" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
  [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
  [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>      
      <th pSortableColumn="startHour" width="100">Hora inicio <p-sortIcon field="startHour"></p-sortIcon></th>      
      <th pSortableColumn="endHour" width="100">Hora fin <p-sortIcon field="endHour"></p-sortIcon></th>      
      <th width="100"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-guardShift let-columns="columns">
    <tr (dblclick)="edit(guardShift)">
      <td>{{guardShift.name}}</td>      
      <td>{{guardShift.startHour}}</td>      
      <td>{{guardShift.endHour}}</td>      
      <td>
        <div class="flex gap-2 justify-content-end">
          <p-button *ngIf="allowDelete" (click)="delete(guardShift)" [rounded]="true" [text]="false" severity="danger"><i
              class="pi pi-trash"></i></p-button>
          <p-button *ngIf="allowWrite" (click)="edit(guardShift)" [rounded]="true" [text]="false"><i
              class="pi pi-pencil"></i></p-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="2">        
         No se han encontrado turnos de guardia
      </td>
    </tr>
  </ng-template>
</p-table>
<p-confirmDialog></p-confirmDialog>